import {interfaceLocale} from '../i18n';
export function weekRangeLabel(date, weekStartsOn='monday', showWeekends=true) {
  const start=new Date(date);start.setHours(0,0,0,0);
  start.setDate(start.getDate()-(start.getDay()-(weekStartsOn==='sunday'?0:1)+7)%7);
  const days=Array.from({length:7},(_,i)=>{const d=new Date(start);d.setDate(d.getDate()+i);return d;}).filter(d=>showWeekends||![0,6].includes(d.getDay()));
  const fmt=new Intl.DateTimeFormat(interfaceLocale(),{day:'numeric',month:'short',year:'numeric'});
  return fmt.formatRange ? fmt.formatRange(days[0],days[days.length-1]) : `${fmt.format(days[0])} – ${fmt.format(days[days.length-1])}`;
}
export function sameCalendarDay(a,b){return !!a&&!!b&&a.getFullYear()===b.getFullYear()&&a.getMonth()===b.getMonth()&&a.getDate()===b.getDate();}
export function monthGridDays(date,weekStartsOn='monday'){
 const start=new Date(date.getFullYear(),date.getMonth(),1);
 start.setDate(start.getDate()-(start.getDay()-(weekStartsOn==='sunday'?0:1)+7)%7);
 return Array.from({length:42},(_,i)=>new Date(start.getFullYear(),start.getMonth(),start.getDate()+i));
}
export function groupDenseAgendaEvents(rows){
 const groups=[];
 for(const row of [...rows].sort((a,b)=>a.start-b.start)){
  const last=groups[groups.length-1];
  if(last&&row.start<last.end){last.rows.push(row);last.end=new Date(Math.max(+last.end,+row.end));}
  else groups.push({rows:[row],start:row.start,end:row.end});
 }
 return groups.flatMap(group=>group.rows.some(row=>row.overlapColumns>2)?[{...group.rows[0],start:group.start,end:group.end,overlapColumns:1,overlapColumn:0,groupEvents:group.rows.map(row=>row.ev)}]:group.rows);
}
